import { observer } from 'mobx-react';
import { FC, useEffect } from 'react';
import { Prompt } from 'react-router';
import ConnectionServices from './containers/ConnectionServices/ConnectionServices';
import takerConnectStore from './store/takerConnectStore';
import { BUTTON_TITLE } from '~/constants/main';
import { SCREENS } from '~/constants/screens';
import { localeStore } from '~/mobx/localesStore';
import { LoadingStatus } from '~/types/main';
import { scrollToErrorElement } from '~/utils/helpers';
import Button from '~/view/components/Controls/ButtonComponent/Button';
import { getPromptProps } from '~/view/components/CustomPrompt/helper';
import LoadingOverlay from '~/view/components/LoadingOverlay/LoadingOverlay';
import Headers from '~/view/containers/Headers/Headers';
import HeaderBack from '~/view/containers/Headers/components/HeaderBack/HeaderBack';
import './style.scss';

const TakerConnect: FC = observer((): JSX.Element => {
  useEffect(() => {
    takerConnectStore.init();
    return () => takerConnectStore.reset();
  }, []);

  const handleSave = () => {
    takerConnectStore.runValidation();

    if (takerConnectStore.validationErrors.senderName || takerConnectStore.validationErrors.userName) {
      scrollToErrorElement();
    } else {
      takerConnectStore.updateTakerConnectData();
    }
  };

  return (
    <div className="d-flex flex-column full-width">
      <Headers>
        <HeaderBack title={localeStore.t('taker_connect')} path={SCREENS.SETTINGS_INTEGRATIONS()} />
      </Headers>

      {takerConnectStore.loadingStatus !== LoadingStatus.Loading ? (
        <div className="taker-connect">
          <ConnectionServices />
          <Button title={localeStore.t(BUTTON_TITLE.SAVE)} onClick={handleSave} className="mt-8" />
        </div>
      ) : null}

      <LoadingOverlay visible={[LoadingStatus.Loading, LoadingStatus.Refreshing].includes(takerConnectStore.loadingStatus)} refreshing />
      <Prompt when={takerConnectStore.isDataEdited} message={getPromptProps()} />
    </div>
  );
});

export default TakerConnect;
